export default "__VITE_ASSET__F0L3Zwqi__"